export async function VismedicasUpdate(
    vismedResp,
    vismedFecha,
    vismedHora,
    vismedObs,
    tratamientoId,
    pacienteId,
    vismedicasId ) {
    const formData = {
        // taxID-mind-mindNumses
        title: `us-${pacienteId}-tr-${tratamientoId}-vismed-${vismedFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-vismed-${vismedFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            vismedResp: vismedResp,
            metaFecha: vismedFecha,
            metaPaciente: pacienteId,
            vismedHora: vismedHora,
            vismedObs: vismedObs,
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch(`https://app.tavad.com/hce/wp-json/wp/v2/vismedicas/${vismedicasId}`, {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}